import React from "react"
import {SelectOneScreen} from "components/SelectOneScreen"

// DTC status options. Exported so the orchestrator can route:
//   First time / Expiring -> Screen 3 (Application Status)
//   Denied -> Auri denial flow (does not continue to eligibility questions)
export const DTC_STATUS_FIRST_TIME =
  "I am applying for the Disability Tax Credit for the first time"
export const DTC_STATUS_EXPIRING =
  "I was previously approved and my certificate has expired or is expiring"
export const DTC_STATUS_DENIED = "I applied and was denied"

const OPTIONS = [DTC_STATUS_FIRST_TIME, DTC_STATUS_EXPIRING, DTC_STATUS_DENIED]

interface EligibilityAppProcessSelectionProps {
  selectedProcess: string
  onSelectedProcess: (answer: string) => void
  onContinue: () => void
  onBack: () => void
}

// Screen 2: DTC status. Moved to the FIRST screen after "Start My Free Check".
export const EligibilityAppProcessSelection: React.FC<
  EligibilityAppProcessSelectionProps
> = (props: EligibilityAppProcessSelectionProps) => {
  const {selectedProcess, onSelectedProcess, onContinue, onBack} = props
  return (
    <SelectOneScreen
      heading="Before we begin, which of the following best describes your situation?"
      options={OPTIONS}
      value={selectedProcess}
      onSelect={onSelectedProcess}
      onContinue={onContinue}
      onBack={onBack}
    />
  )
}

export default EligibilityAppProcessSelection
